import React from "react";

export default function OwnerBadge({ item }) {
  if (!item.owner_name) return null;
  return (
    <span
      className="inline-flex items-center gap-1 text-[10px] font-semibold px-1.5 py-0.5 rounded bg-blue-100 text-blue-800 border border-blue-200 flex-shrink-0"
      title={`Creat de ${item.owner_name}`}
    >
      👤 {item.owner_name}
    </span>
  );
}
